<nb-actions size="tiny" class="contacts">
    <nb-action class="control-item" icon="phone"></nb-action>
    <nb-action class="custom-action">5241625227</nb-action>
    <nb-action class="control-item" icon="email"></nb-action>
  </nb-actions>
